{
  "name": "@uppy/core",
  "description": "Core module for the extensible JavaScript file upload widget with support for drag&drop, resumable uploads, previews, restrictions, file processing/encoding, remote providers like Instagram, Dropbox, Google Drive, S3 and more :dog:",
  "version": "4.5.2",
  "license": "MIT",
  "main": "lib/index.js",
  "style": "dist/style.min.css",
  "type": "module",
  "sideEffects": [
    "*.css"
  ],
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "build:css": "sass --load-path=../../ src/style.scss dist/style.css && postcss dist/style.css -u cssnano -o dist/style.min.css",
    "typecheck": "tsc --build",
    "test": "vitest run --environment=jsdom --silent='passed-only'"
  },
  "keywords": [
    "file uploader",
    "uppy",
    "uppy-plugin"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "dependencies": {
    "@transloadit/prettier-bytes": "^0.3.4",
    "@uppy/store-default": "workspace:^",
    "@uppy/utils": "workspace:^",
    "lodash": "^4.17.21",
    "mime-match": "^1.0.2",
    "namespace-emitter": "^2.0.1",
    "nanoid": "^5.0.9",
    "preact": "^10.5.13"
  },
  "devDependencies": {
    "@types/deep-freeze": "^0",
    "cssnano": "^7.0.7",
    "deep-freeze": "^0.0.1",
    "jsdom": "^26.1.0",
    "postcss": "^8.5.6",
    "postcss-cli": "^11.0.1",
    "sass": "^1.89.2",
    "typescript": "^5.8.3",
    "vitest": "^3.2.4"
  }
}
